import SoundArchivePage from './SoundArchivePage';

export default SoundArchivePage;
